module.exports = __webpack_public_path__ + "img/cloudClincIconB.1c8b033b.svg";